module.exports = __webpack_public_path__ + "img/BG2.e4e5d633.png";